/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Inheritedcolordefinitions2Inputs */

const en__field_inheritedcolordefinitions2 = /** @type {(inputs: _Field_Inheritedcolordefinitions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Colors (inherited)`)
};

const de__field_inheritedcolordefinitions2 = /** @type {(inputs: _Field_Inheritedcolordefinitions2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Farben (abgeleitet)`)
};

/**
* | output |
* | --- |
* | "Colors (inherited)" |
*
* @param {_Field_Inheritedcolordefinitions2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_inheritedcolordefinitions2 = /** @type {((inputs?: _Field_Inheritedcolordefinitions2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Inheritedcolordefinitions2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_inheritedcolordefinitions2(inputs)
	return de__field_inheritedcolordefinitions2(inputs)
});
export { _field_inheritedcolordefinitions2 as "_field_inheritedColorDefinitions" }